import * as z from "zod/v4";

const mobileMessageDetail = z.object({
  conversationId: z.string(),
  customerPhone: z.string(),
  ourPhone: z.string(),
  aiDisabled: z.boolean(),
  createdAt: z.string(),
  messages: z.array(
    z.object({
      content: z.string(),
      senderType: z.string(),
      sentAt: z.string(),
    }),
  ),
  flows: z.array(
    z.object({
      id: z.string(),
      flowType: z.string(),
      flowStatus: z.string(),
      firstMessageSentAt: z.string().nullable(),
      createdAt: z.string(),
    }),
  ),
});

export const getMobileMessageConversationDetail = {
  name: "getMobileMessageConversationDetail" as const,
  input: z.object({ conversationId: z.string() }),
  output: mobileMessageDetail,
};
